export const SET_SOLAR_PRODUCT_PAGE = "setSolarProductPage";
export const SET_BATTERIES_PRODUCT_PAGE = "setBatteriesProductPage";
export const SET_PRODUCT_RESOURCE = "setProductResource";
